import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../About/About.css";
import { FaPhoneAlt } from "react-icons/fa";
import { GiCalculator } from "react-icons/gi";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  useEffect(() => {
    // GSAP ScrollTrigger animation for the about image (rolling open from left to right)
    gsap.fromTo(
      ".about-image-wa",
      {
        scaleX: 0, // Start with 0 scaleX (collapsed)
        transformOrigin: "left center", // Scale from the left side
      },
      {
        scaleX: 1, // Scale to full width (unfolded)
        duration: 3, // Duration to make it feel smooth
        ease: "power2.inOut", // Smooth easing for both forward and backward scroll
        scrollTrigger: {
          trigger: ".about-right-wa", // Element to trigger animation
          start: "top 80%", // Trigger when the top of the element reaches 80% from the top of the viewport
          end: "bottom 50%", // End the animation before the section ends
          scrub: 1.5, // Longer scrub time for smoothness (1.5 seconds)
          // Optional markers to visualize scroll trigger points for debugging
        },
      },
    );

    // GSAP ScrollTrigger animation for the text elements (scaling up and fading in)
    gsap.fromTo(
      ".heading-sub-wa, .heading-main-wa, .description-wa, .contact-title-wa, .contact-wa",
      {
        opacity: 0, // Start with 0 opacity (invisible)
        y: 50, // Start with a downward offset
        scale: 0.8, // Start with smaller size
      },
      {
        opacity: 1, // Fade in to full opacity
        y: 0, // Move to original position
        scale: 1, // Scale to original size
        duration: 1.5, // Duration of the animation
        ease: "power2.out", // Smooth easing
        stagger: 0.3, // Stagger the animations for each element
        scrollTrigger: {
          trigger: ".about-left-wa", // Element to trigger animation
          start: "top 80%", // Trigger when the top of the element reaches 80% from the top of the viewport
          end: "bottom 50%", // End the animation before the section ends
          scrub: 1.5, // Longer scrub time for smoothness
          // Optional markers to visualize scroll trigger points for debugging
        },
      },
    );
  }, []);

  return (
    <section className="about-section-wa">
      <div className="about-left-wa">
        <div className="icon-line-wa">
          <GiCalculator className="react-icon-wa" />
        </div>
        <h5 className="heading-sub-wa">Welcome to Our Firm</h5>
        <h1 className="heading-main-wa">We Are Your CA Partner</h1>
        <p className="description-wa">
          With years of experience and dedication, we provide expert financial
          solutions, specializing in taxation, auditing, and compliance for
          individuals and businesses across India.
        </p>
        <h5 className="contact-title-wa">Contact Our Specialists:</h5>
        <div className="contact-wa">
          <FaPhoneAlt className="contact-icon-wa" />
          <span className="contact-number-wa">+91 000000000</span>
        </div>
      </div>
      <div className="about-right-wa">
        <img src="/about.webp" alt="Our CA Team" className="about-image-wa" />
      </div>
    </section>
  );
};

export default About;
